<template>
  <v-row align-center justify-center :class="{ fullSize: loading }" class="bootstrapDefault mx-0">
    <v-col class="pa-0 generalClass-table-padding">
      <loading-page v-if="loading"></loading-page>

      <default-page
          v-else-if="error || !eventRules.length"
          imageUrl="/img/dynamic-src-images/event-rules.svg"
          title="Event Rules"
          text="It seems that you don't have any event rules|Click Get Started below to add an event rule"
          :buttonText="error ? 'Reload' : 'Get Started'"
          :errorMessage="error ? errorMessage.message : ''"
          @button-clicked="buttonClicked"
      ></default-page>

      <div v-else>
        <confirm-dialog
            :dialog="confirmDialog"
            @confirmation-event="deleteRule($event)"
            @mutate-confirm-dialog="mutateConfirmDialog"
            :text="itemDeletionText"
            :acceptButton="'Delete'"
        ></confirm-dialog>
        <v-row no-gutters>
          <v-col cols="12">
            <v-data-table
                :mobile-breakpoint="0"
                :height="windowSizeY - 100"
                :items-per-page="itemsPerPage"
                :page.sync="page"
                fixed-header
                :custom-sort="currentSortingAlgo"
                dense
                style="border-bottom: none;"
                class="main_page_table eventRulesTable"
                hide-default-header
                hide-default-footer
                flat
                :headers="headers"
                sort-by="id"
                single-expand
                :items="eventRules"
                :expanded.sync="expanded"
            >
              <template v-slot:header="{ props: { headers } }">
                <thead>
                <tr v-if="$vuetify.breakpoint.mdAndUp">
                  <th
                      v-for="header in headers.filter(
                        (el) => el.value !== 'application'
                      )"
                      :key="header.value"
                      class="allTableHeaders"
                  >
                    <v-row align="center" justify="center">
                      <v-col height="100%">
                        <v-row
                            :class="
                              header.value === 'expand' ||
                              header.value === 'activate'
                                ? 'pl-0'
                                : 'pl-3'
                            "
                            :style="
                              header.value === 'expand' ||
                              header.value === 'activate'
                                ? 'justify-content: center;'
                                : ''
                            "
                        >
                          <v-hover v-slot:default="{ hover }">
                            <p
                                :class="
                                  header.value === 'expand' ||
                                  header.value === 'activate'
                                    ? 'text-center'
                                    : 'allTableHeadersHover'
                                "
                                class="my-0 fullHeight"
                                @click="
                                  currentSortingAlgo = getNewSortingAlgo(
                                    header
                                  );
                                  selectedHeader = header.value;
                                "
                            >
                              {{ header.text }}
                              <v-icon
                                  v-show="
                                    header.value !== 'expand' &&
                                      header.value !== 'activate'
                                  "
                                  :style="
                                    !hover && (selectedHeader !== header.value)
                                      ? 'opacity: 0.2;'
                                      : 'opacity: 1;'
                                  "
                                  style="font-size: 12px;margin-left: -3px;"
                              >{{ getSortingIcon(header.currentSortAlg) }}
                              </v-icon>
                            </p>
                          </v-hover>
                        </v-row>
                      </v-col>
                    </v-row>
                  </th>
                </tr>
                <tr v-else-if="$vuetify.breakpoint.width > 525" class="force-width-100">
                  <th v-for="(number, index) in 4" :key="index" class="allTableHeaders">
                    <v-row align="center" justify="center">
                      <v-col height="100%">
                        <v-row
                            :class="
                              headers[index].value === 'expand' ? 'pl-0' : 'pl-3'
                            "
                            :style="
                              headers[index].value === 'expand'
                                ? 'justify-content: center;'
                                : ''
                            "
                        >
                          <v-hover v-slot:default="{ hover }">
                            <p
                                :class="
                                  headers[index].value === 'expand' ||
                                  headers[index].value === 'activate'
                                    ? 'text-center'
                                    : 'allTableHeadersHover'
                                "
                                class="my-0 fullHeight"
                                @click="
                                  currentSortingAlgo = getNewSortingAlgo(
                                    headers[index]
                                  );
                                  selectedHeader = headers[index].value;
                                "
                            >
                              {{ headers[index].text }}
                              <v-icon
                                  v-show="
                                    headers[index].value !== 'expand' &&
                                      headers[index].value !== 'activate'
                                  "
                                  :style="
                                    !hover &&
                                    (selectedHeader !== headers[index].value)
                                      ? 'opacity: 0.2;'
                                      : 'opacity: 1;'
                                  "
                                  style="font-size: 12px;margin-left: -3px;"
                              >
                                {{
                                  getSortingIcon(
                                      headers[index].currentSortAlg
                                  )
                                }}
                              </v-icon>
                            </p>
                          </v-hover>
                        </v-row>
                      </v-col>
                    </v-row>
                  </th>
                </tr>
                <tr v-else class="force-width-100">
                  <th class="allTableHeaders">
                    <v-row align="center" justify="center">
                      <v-col height="100%">
                        <v-row
                            :class="
                              headers[0].value === 'expand' ? 'pl-0' : 'pl-3'
                            "
                            justify="center"
                        >
                          <v-hover v-slot:default="{ hover }">
                            <p
                                :class="
                                  headers[0].value === 'expand' ||
                                  headers[0].value === 'activate'
                                    ? 'text-center'
                                    : 'allTableHeadersHover'
                                "
                                class="my-0 fullHeight"
                                @click="
                                  currentSortingAlgo = getNewSortingAlgo(
                                    headers[0]
                                  );
                                  selectedHeader = headers[0].value;
                                "
                            >
                              {{ headers[1].text }}
                              <v-icon
                                  v-show="
                                    headers[0].value !== 'expand' &&
                                      headers[0].value !== 'activate'
                                  "
                                  :style="
                                    !hover && selectedHeader !== headers[0].value
                                      ? 'opacity: 0.2;'
                                      : 'opacity: 1;'
                                  "
                                  style="font-size: 12px;margin-left: -3px;"
                              >
                                {{
                                  getSortingIcon(headers[0].currentSortAlg)
                                }}
                              </v-icon>
                            </p>
                          </v-hover>
                        </v-row>
                      </v-col>
                    </v-row>
                  </th>
                </tr>
                </thead>
              </template>
              <template v-slot:item="{ item,index }">
                <tr
                    v-if="$vuetify.breakpoint.mdAndUp"
                    :class="
                    $vuetify.theme.dark ? 'backgroundBlack' : 'backgroundWhite'
                  "
                >
                  <td class="char-lim">{{ item.name }} ({{ item.application }})</td>
                  <td>{{ item.priority }}</td>
                  <td class="char-lim">{{ item.namespace }}</td>
                  <td class="char-lim">{{ item.description }}</td>
                  <td class="px-0" style="text-align: center !important;">
                    <v-switch
                        class="mt-0 rule-switch"
                        v-model="item.enabled"
                        color="primary"
                        @change="switchRule(item.enabled, item)"
                    ></v-switch>
                  </td>
                  <td class="text-center">
                    <v-btn
                        :id="`edit-eventrule${index}`"
                        icon
                        @click="
                            editRule(item);
                            expandRow(item);
                          "
                    >
                      <span style="font-size: 28px;" class="icon-edit-21x21">
                        <span class="path1 letterSpacing0"></span>
                        <span class="path2"></span>
                      </span>
                    </v-btn>
                    <v-tooltip :activator="`#edit-eventrule${index}`" class="mt-3 ml-1" bottom>
                      <span>Edit</span>
                    </v-tooltip>

                    <v-btn :id="`delete-eventrule${index}`" icon @click="confirmationDialog(item)">
                      <span style="font-size: 28px;" class="icon-delete-21x21">
                        <span class="path1 letterSpacing0"></span>
                        <span class="path2"></span>
                      </span>
                    </v-btn>
                    <v-tooltip :activator="`#delete-eventrule${index}`" class="mt-3 ml-1" bottom>
                      <span>Delete</span>
                    </v-tooltip>
                  </td>
                </tr>

                <tr
                    v-else-if="$vuetify.breakpoint.width > 525"
                    :id="
                    $vuetify.theme.dark
                      ? 'dataTableRow_dark'
                      : 'dataTableRow_light'
                  "
                    @click="expandRow(item)"
                    class="rowClick force-width-100"
                >
                  <td class="char-lim">
                    <v-icon
                        :class="
                        expanded.some((el) => el.id === item.id)
                          ? 'red--text pr-1'
                          : 'primary--text pr-1'
                      "
                        style="font-size: 16px;"
                    >
                      {{
                        expanded.some((el) => el.id === item.id)
                            ? "fas fa-times-circle"
                            : "fas fa-chevron-circle-down"
                      }}
                    </v-icon>
                    {{ item.name }} ({{ item.application }})
                  </td>
                  <td class="table_Row">{{ item.application }}</td>
                  <td>{{ item.priority }}</td>

                  <td class="char-lim">{{ item.namespace }}</td>
                </tr>
                <tr
                    v-else
                    :id="
                    $vuetify.theme.dark
                      ? 'dataTableRow_dark'
                      : 'dataTableRow_light'
                  "
                    @click="expandRow(item)"
                    style="height: 32px;"
                    class="rowClick force-width-100"
                >
                  <td>
                    <v-row justify="center" align="center">
                      <v-col class="pa-0" cols="4"></v-col>
                      <v-col class="pa-0" cols="8">
                        <div class="char-lim ml-4">
                          <v-icon
                              :class="
                              expanded.some((el) => el.id === item.id)
                                ? 'red--text pr-1'
                                : 'primary--text pr-1'
                            "
                              style="font-size: 16px;"
                          >
                            {{
                              expanded.some((el) => el.id === item.id)
                                  ? "fas fa-times-circle"
                                  : "fas fa-chevron-circle-down"
                            }}
                          </v-icon>
                          {{ item.name }} ({{ item.application }})
                        </div>
                      </v-col>
                    </v-row>
                  </td>
                </tr>
              </template>
              <template v-slot:expanded-item="{ item }">
                <!-- <div></div> -->
                <td :colspan="countOfHeadersShowing">

                  <div v-if="$vuetify.breakpoint.smAndDown" class="expandBackground">
                    <v-row
                        v-if="$vuetify.breakpoint.width <= 525"
                        style="height: 32px;"
                        class="expandRowClass_Border mx-0"
                        justify="space-around"
                    >
                      <v-col v-if="$vuetify.breakpoint.width <= 525" cols="1"></v-col>
                      <v-col class="py-1 pr-0" style="font-weight: 600; font-size: 14px;" cols="3">
                        <p class="pl-3">Priority</p>
                      </v-col>
                      <v-col
                          class="py-1 px-0 text-center"
                          style="font-size: 14px;"
                          cols="8"
                      >{{ item["priority"] }}
                      </v-col>
                    </v-row>
                    <v-row
                        v-if="$vuetify.breakpoint.width <= 525"
                        style="height: 32px;"
                        class="expandRowClass_Border mx-0"
                        justify="space-around"
                    >
                      <v-col v-if="$vuetify.breakpoint.width <= 525" cols="1"></v-col>
                      <v-col class="py-1 pr-0" style="font-weight: 600; font-size: 14px;" cols="3">
                        <p class="pl-3">Namespace</p>
                      </v-col>
                      <v-col
                          class="py-1 text-center"
                          style="font-size: 14px;"
                          cols="8"
                      >{{ item["namespace"] }}
                      </v-col>
                    </v-row>
                    <v-row
                        style="height: 32px;"
                        class="expandRowClass_Border mx-0"
                        justify="space-around"
                    >
                      <v-col v-if="$vuetify.breakpoint.width <= 525" cols="1"></v-col>
                      <v-col class="py-1 pr-0" style="font-weight: 600; font-size: 14px;" cols="3">
                        <p class="pl-3">Description</p>
                      </v-col>
                      <v-col
                          class="py-1 text-center"
                          style="font-size: 14px;"
                          cols="8"
                      >{{ item["description"] }}
                      </v-col>
                    </v-row>
                    <v-row
                        style="max-height: 32px"
                        class="expandRowClass_Border mx-0"
                        justify="space-around"
                    >
                      <v-col v-if="$vuetify.breakpoint.width <= 525" cols="1"></v-col>
                      <v-col
                          class="py-1"
                          style="max-height: 32px;font-weight: 600; font-size: 14px;"
                          cols="3"
                      >
                        <p class="pl-3">Activate</p>
                      </v-col>
                      <v-col class="py-0" style="font-size: 14px;" cols="8">
                        <v-switch
                            class="mt-0"
                            style="max-height: 32px;width: 100%;max-width: 40px;margin-left: auto;margin-right: auto; text-align: center; "
                            v-model="item.enabled"
                            color="primary"
                            @change="
                            item.enabled
                              ? switchRule(
                                  true,
                                  item.id,
                                  item.name,
                                  item.namespace
                                )
                              : switchRule(
                                  false,
                                  item.id,
                                  item.name,
                                  item.namespace
                                )
                          "
                        ></v-switch>
                      </v-col>
                    </v-row>
                    <v-row class="actions_header mx-0" justify="space-around">
                      <v-col v-if="$vuetify.breakpoint.width <= 525" cols="1"></v-col>
                      <v-col class="py-1" style="font-weight: 600; font-size: 14px;" cols="3">
                        <p class="pl-3 mb-0">Actions</p>
                      </v-col>
                      <v-col class="pa-0 text-center" cols="8">
                        <v-btn
                            height="32"
                            icon
                            @click="
                            editRule(item);
                            showQueryBuilder = !showQueryBuilder;
                          "
                        >
                          <span style="font-size: 28px;" class="icon-edit-21x21">
                            <span class="path1 letterSpacing0"></span>
                            <span class="path2"></span>
                          </span>
                        </v-btn>

                        <v-btn height="32" icon @click="confirmationDialog(item)">
                          <span style="font-size: 28px;" class="icon-delete-21x21">
                            <span class="path1 letterSpacing0"></span>
                            <span class="path2"></span>
                          </span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                  <div
                      v-if="showQueryBuilder || $vuetify.breakpoint.mdAndUp"
                      :class="$vuetify.theme.dark ? 'noHoverBackground-dark' : ''"
                      flat
                  >
                    <v-card flat>
                      <v-row
                          v-if="$vuetify.breakpoint.smAndUp"
                          justify="space-around"
                          v-bind:class="
                          $vuetify.theme.dark
                            ? 'queryBuilder--dark queryBackground_dark'
                            : 'queryBuilder--light queryBackground_light'
                        "
                          class="mx-0"
                      >
                        <v-col cols="12" sm="6">
                          <vue-query-builder :maxDepth="5" :rules="rules" v-model="query"></vue-query-builder>
                        </v-col>
                        <v-col cols="12" sm="6" md="5" lg="4">
                          <v-form ref="rulesForm" v-model="validExpand">
                            <v-text-field
                                class="pa-0 ma-0"
                                dense
                                outlined
                                label="Rule description"
                                v-model="newEventRuleObject.description"
                                :rules="[validationRules.maxCharDescription]"
                                counter
                                hint="Max 200 Character"
                            ></v-text-field>
                            <v-text-field
                                autofocus
                                class="pa-0 ma-0"
                                dense
                                outlined
                                label="Rule name"
                                v-model="newEventRuleObject.name"
                                :rules="[
                                validationRules.required,
                                validationRules.maxCharName,
                              ]"
                                counter
                                hint="Max 50 Character"
                            ></v-text-field>
                            <v-text-field
                                class="pa-0 ma-0 textFieldHeight"
                                dense
                                outlined
                                label="Rule namespace"
                                v-model="newEventRuleObject.namespace"
                                :rules="[validationRules.maxCharName]"
                                counter
                                hint="Max 50 Character"
                            ></v-text-field>
                            <input-wrapper2 label="Subscription Groups" full-width>
                              <subscription-groups :event-rule="newEventRuleObject"/>
                            </input-wrapper2>
                            <v-row justify="end">
                              <v-btn text @click="expanded = []">Cancel</v-btn>
                              <v-btn
                                  @click="
                                  saveHandler();
                                  expanded = [];
                                "
                                  :disabled="!validExpand"
                                  color="primary"
                                  text
                              >Save
                              </v-btn>
                            </v-row>
                          </v-form>
                        </v-col>
                      </v-row>
                      <v-row
                          v-else
                          justify="space-around"
                          v-bind:class="
                          $vuetify.theme.dark
                            ? 'queryBuilder--dark queryBackground_dark'
                            : 'queryBuilder--light queryBackground_light'
                        "
                          class="mx-0"
                      >
                        <v-col class="pb-0" cols="12" sm="6" md="5" lg="4">
                          <v-form ref="rulesForm" v-model="validExpand">
                            <v-text-field
                                class="pa-0 ma-0"
                                dense
                                outlined
                                label="Rule description"
                                v-model="newEventRuleObject.description"
                                :rules="[validationRules.maxCharDescription]"
                                counter
                                hint="Max 200 Character"
                            ></v-text-field>
                            <v-text-field
                                autofocus
                                class="pa-0 ma-0"
                                dense
                                outlined
                                label="Rule name"
                                v-model="newEventRuleObject.name"
                                :rules="[
                                validationRules.required,
                                validationRules.maxCharName,
                              ]"
                                counter
                                hint="Max 50 Character"
                            ></v-text-field>
                            <v-text-field
                                class="pa-0 ma-0 textFieldHeight"
                                dense
                                outlined
                                label="Rule namespace"
                                v-model="newEventRuleObject.namespace"
                                :rules="[validationRules.maxCharName]"
                                counter
                                hint="Max 50 Character"
                            ></v-text-field>
                            <v-row justify="end">
                              <v-btn text @click="expanded = []">Cancel</v-btn>
                              <v-btn
                                  @click="
                                  saveHandler();
                                  expanded = [];
                                "
                                  :disabled="!validExpand"
                                  color="primary"
                                  text
                              >Save
                              </v-btn>
                            </v-row>
                          </v-form>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <vue-query-builder :maxDepth="5" :rules="rules" v-model="query.children"></vue-query-builder>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </td>
              </template>
              <template v-slot:no-data>
                <v-alert :value="true" color="primary" icon="warning" outlined>
                  It seems that you don't have any rules. Click at
                  <v-icon>add</v-icon>&nbsp;to add a rule!
                </v-alert>
              </template>
            </v-data-table>
            <div class="text-center custom-table-footer">
              <v-row
                  justify="space-between"
                  justify-sm="end"
                  class="mx-0"
              >
                <div
                    class="ml-2 pagination-item-1"
                >
                  <div
                      v-if="$vuetify.breakpoint.smAndUp"
                      class="mr-6"
                  >
                    Rows per page:
                  </div>
                  <div
                      :class="{ 'mr-1': $vuetify.breakpoint.smAndUp }"
                      class="footer-items-wrapper"
                  >
                    <v-select
                        dense
                        class="footer-items-per-page mt-0"
                        hide-details
                        :menu-props="{ top: true, offsetY: true }"
                        :items="[10, 25, 50, 100]"
                        v-model="itemsPerPage"
                        @change="paginationChangeHandler(1)"
                    >
                      <template v-slot:item="{ item }">
                        <div class="mb-0 char-lim-tabs page-rows-selection">
                          <div v-if="item === -1">All</div>
                          <div v-else>{{ item }}</div>
                        </div>
                      </template>
                      <template v-slot:selection="{ item }">
                        <div class="page-rows-selection">
                          <div v-if="item === -1">
                            All
                          </div>
                          <div v-else>
                            {{ item }}
                          </div>
                        </div>
                      </template>
                    </v-select>
                  </div>
                </div>
                <v-pagination
                    v-model="page"
                    @input="paginationChangeHandler"
                    :length="totalPages"
                    :total-visible="$vuetify.breakpoint.xsOnly ? 5 : 7"
                    circle
                    class="pagination"
                ></v-pagination>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
      <v-btn
          v-if="!loading && !error && eventRules.length"
          fab
          bottom
          right
          :style="{ bottom: '70px' }"
          :color="$vuetify.theme.dark ? '#685AA1' : 'primary'"
          dark
          fixed
          @click="addEventRule"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-dialog
          transition="scroll-x-transition"
          overlay-color="grey darken-2"
          v-model="dialog"
          max-width="750px"
          persistent
      >
        <v-card color="accent">
          <v-card-title style="background-color:#47BD96;color:white">
            New Rule
          </v-card-title>
          <v-container grid-list-sm class="pa-4 pb-0">
            <v-form :lazy-validation="false" ref="confRulesForm" class="pt-4" v-model="valid">
              <v-row>
                <v-col class="py-0" cols="12" sm="6">
                  <v-text-field
                      autofocus
                      dense
                      outlined
                      label="Rule name"
                      v-model="newEventRuleObjectForDialog.name"
                      :rules="[
                        validationRules.required,
                        validationRules.maxCharName,
                      ]"
                      counter
                      hint="Max 50 Character"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <v-text-field
                      dense
                      outlined
                      label="Rule description"
                      v-model="newEventRuleObjectForDialog.description"
                      :rules="[validationRules.maxCharDescription]"
                      counter
                      hint="Max 200 Character"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>

                <v-col class="py-0" cols="12" sm="6">
                  <v-text-field
                      dense
                      outlined
                      label="Rule namespace"
                      v-model.trim="newEventRuleObjectForDialog.namespace"
                      :rules="[validationRules.maxCharName]"
                      counter
                      hint="Max 50 Character"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn text @click="dialog = false">Cancel</v-btn>
            <v-btn
                @click="$refs.confRulesForm.validate() ? saveHandler() : false"
                color="primary"
                text
            >Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
import {EventRuleService, ApplicationService} from "@/services/ApiService";
import {defaultEventRule} from "@/utilities/DefaultObjects.js";
import VueQueryBuilder from "vue-query-builder";
import {
  LoadingPage,
  DefaultPage,
  ConfirmDialog,
} from "../components/Default-Page-Components";
import SubscriptionGroups from "@/components/EventRules/SubscriptionGroups.vue";
import InputWrapper2 from "@/components/UI/InputWrapper2.vue";

export default {
  components: {InputWrapper2, SubscriptionGroups, VueQueryBuilder, ConfirmDialog, LoadingPage, DefaultPage},
  data() {
    return {
      page: 1,
      totalPages: 0,
      itemsPerPage: 25,
      itemToDelete: {},
      confirmDialog: false,
      valid: false,
      validExpand: false,
      validationRules: {
        required: (val) => !!val || "Required",
        maxCharDescription: (val) => val === undefined || val.length < 201,
        maxCharName: (val) => val === undefined || val.length < 51,
      },
      COLUMN_SORTS: {
        NUMBERS: {DESC: 0, ASC: 1},
        STRINGS: {DESC: 2, ASC: 3},
      },
      selectedHeader: "",
      currentSortingAlgo: (items) => items,
      showQueryBuilder: false,
      itemEnabled: false,
      expanded: [],
      edit: false,
      add: false,
      applications: [],
      dialog: false,
      error: 0,
      errorMessage: "",
      loading: false,
      eventRules: [],
      newEventRuleObjectForDialog: {
        application: "",
        description: "",
        enabled: false,
        expression: "",
        id: 0,
        name: "",
        namespace: "",
        priority: 0,
      },
      newEventRuleObject: {
        application: "",
        description: "",
        enabled: false,
        expression: "",
        id: 0,
        name: "",
        namespace: "",
        priority: 0,
        subscriptionGroups: [],
      },
      rules: [
        {
          type: "text",
          id: "lastUpdate",
          label: "Last Updated",
          operators: ["<", ">", "=", "<=", ">=", "<>"],
        },
        {
          type: "text",
          id: "bid",
          label: "Bid",
          operators: ["<", ">", "=", "<=", ">=", "<>"],
        },
        {
          type: "text",
          id: "ask",
          label: "Ask",
          operators: ["<", ">", "=", "<=", ">=", "<>"],
        },
        {
          type: "text",
          id: "spread",
          label: "Spread",
          operators: ["<", ">", "=", "<=", ">=", "<>"],
        },
        {
          type: "text",
          id: "time",
          label: "Server Time (in minutes from midnight in UTC)",
          operators: ["<", ">", "=", "<=", ">=", "<>"],
        },
        {
          type: "text",
          id: "symbol",
          label: "Symbol",
          operators: [
            "Begins with",
            "Doesn't begin with",
            "Ends with",
            "Doesn't end with",
            "Contains",
            "Doesn't contain",
            "Equals to",
            "Not equal to",
            "Equals to(not case senstive)",
            "Length",
          ],
        },
        {
          type: "text",
          id: "security",
          label: "Security",
          operators: [
            "Begins with",
            "Doesn't begin with",
            "Ends with",
            "Doesn't end with",
            "Contains",
            "Doesn't contain",
            "Equals to",
            "Not equal to",
            "Equals to(not case senstive)",
          ],
        },
        {
          type: "text",
          id: "identity",
          label: "Name of server",
          operators: [
            "Begins with",
            "Doesn't begin with",
            "Ends with",
            "Doesn't end with",
            "Contains",
            "Doesn't contain",
            "Equals to",
            "Not equal to",
            "Equals to(not case senstive)",
          ],
        },
        {
          type: "select",
          id: "status",
          label: "Status",
          operators: [
            "Equals to",
            "Not equals",
          ],
          choices: [
            {label: "Unknown", value: "UNKNOWN"},
            {label: "First quote", value: "FIRST_QUOTE"},
            {label: "Missed first quote ", value: "MISSED_FIRST_QUOTE"},
            {label: "Quote update", value: "QUOTE_UPDATE"},
            {label: "Outdated quote", value: "OUTDATED_QUOTE"},
            {label: "Problematic first quote", value: "PROBLEMATIC_FIRST_QUOTE"},
            {label: "Problematic sequential quote", value: "PROBLEMATIC_SEQUENTIAL_QUOTE"},
          ],
        },
      ],
      query: {},
      headers: [
        {
          text: "Application",
          value: "application",
          align: "left",
          sortable: false,
          type: "String",
          currentSortAlg: null,
        },
        {
          text: "Name",
          value: "name",
          sortable: false,
          type: "String",
          currentSortAlg: null,
        },

        {
          text: "Priority",
          value: "priority",
          sortable: false,
          type: "String",
          currentSortAlg: null,
        },
        {
          text: "Namespace",
          value: "namespace",
          sortable: false,
          type: "String",
          currentSortAlg: null,
        },
        {
          text: "Description",
          value: "description",
          sortable: false,
          type: "String",
          currentSortAlg: null,
        },
        {
          text: "Activate",
          sortable: false,
          value: "activate",
          type: "String",
          currentSortAlg: null,
        },
        {
          text: "Actions",
          sortable: false,
          value: "expand",
        },
      ],
    };
  },
  props: {
    isNotDesktop: {
      type: Boolean,
      default: false,
    },
    windowSizeY: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    countOfHeadersShowing() {
      if (this.$vuetify.breakpoint.mdAndUp)
        return this.headers.length
      else if (this.$vuetify.breakpoint.width > 525) return 4
      else return 1

    },
    itemDeletionText() {
      return Object.keys(this.itemToDelete).length
          ? `Delete rule ${this.itemToDelete.name} ?`
          : "";
    },
  },
  created() {
    if (window.innerWidth > 320 && !this.isNotDesktop) {
      document.getElementById("htmlId").style.overflowY = "hidden";
    }
    this.loading = true;
    this.getEventRulesFromServer();
  },
  methods: {
    paginationChangeHandler(page) {
      this.page = page;
      this.getEventRulesFromServer();
    },
    getDefinitionsQueryParams() {
      return {
        size: this.itemsPerPage,
        page: this.page - 1,
      }
    },
    buttonClicked() {
      if (this.error) this.reloadThisPage();
      else this.addEventRule();
    },
    mutateConfirmDialog(value) {
      this.confirmDialog = value;
    },
    confirmationDialog(item) {
      this.itemToDelete = item;
      this.confirmDialog = !this.confirmDialog;
    },
    getSortingIcon(algo) {
      switch (algo) {
        case this.COLUMN_SORTS.NUMBERS.ASC:
        case this.COLUMN_SORTS.STRINGS.ASC:
          return "fas fa-arrow-down";
        default:
          return "fas fa-arrow-up";
      }
    },
    clearAllHeadersSorting(header) {
      this.headers.map((el) => {
        if (el.text !== header.text && el.currentSortAlg != null) {
          el.currentSortAlg = null;
          return el;
        } else {
          return el;
        }
      });
    },
    getNewSortingAlgo(header) {
      if (header.text !== this.selectedSort) {
        this.selectedSort = this.headers.find(
            (el) => el.value === header.value
        ).text;
      }
      switch (header.type) {
        case "Number":
          if (
              header.currentSortAlg == null ||
              header.currentSortAlg === this.COLUMN_SORTS.NUMBERS.DESC
          ) {
            header.currentSortAlg = this.COLUMN_SORTS.NUMBERS.ASC;
            this.clearAllHeadersSorting(header);
            return this.numSortAsc;
          } else {
            header.currentSortAlg = this.COLUMN_SORTS.NUMBERS.DESC;
            this.clearAllHeadersSorting(header);
            return this.numSortDesc;
          }
        case "String":
          if (
              header.currentSortAlg == null ||
              header.currentSortAlg === this.COLUMN_SORTS.STRINGS.DESC
          ) {
            header.currentSortAlg = this.COLUMN_SORTS.STRINGS.ASC;
            this.clearAllHeadersSorting(header);
            return this.stringSortAsc;
          } else {
            header.currentSortAlg = this.COLUMN_SORTS.STRINGS.DESC;
            this.clearAllHeadersSorting(header);
            return this.stringSortDesc;
          }
      }
    },
    numSortAsc(items) {
      return this.secondarySort(items, this.COLUMN_SORTS.NUMBERS.ASC);
    },
    numSortDesc(items) {
      return this.secondarySort(items, this.COLUMN_SORTS.NUMBERS.DESC);
    },
    stringSortAsc(items) {
      return this.secondarySort(items, this.COLUMN_SORTS.STRINGS.ASC);
    },
    stringSortDesc(items) {
      return this.secondarySort(items, this.COLUMN_SORTS.STRINGS.DESC);
    },
    secondarySort(items, typeAndOrder) {
      switch (typeAndOrder) {
        case this.COLUMN_SORTS.NUMBERS.ASC:
          return items.sort(
              (a, b) => a[this.selectedHeader] - b[this.selectedHeader]
          );
        case this.COLUMN_SORTS.NUMBERS.DESC:
          return items.sort(
              (a, b) => b[this.selectedHeader] - a[this.selectedHeader]
          );
        case this.COLUMN_SORTS.STRINGS.ASC:
          return items.sort((a, b) =>
              a[this.selectedHeader] > b[this.selectedHeader]
                  ? 1
                  : b[this.selectedHeader] > a[this.selectedHeader]
                      ? -1
                      : 0
          );
        case this.COLUMN_SORTS.STRINGS.DESC:
          return items.sort((a, b) =>
              b[this.selectedHeader] > a[this.selectedHeader]
                  ? 1
                  : a[this.selectedHeader] > b[this.selectedHeader]
                      ? -1
                      : 0
          );
      }
    },
    expandRow(item) {
      this.showQueryBuilder = false;
      if (this.expanded.length) {
        if (this.expanded[0].id === item.id) {
          this.expanded.pop();
        } else {
          this.expanded.pop();
          this.expanded.push(item);
        }
      } else {
        this.expanded.push(item);
      }
    },
    reloadThisPage() {
      this.loading = true;
      this.getEventRulesFromServer();
    },
    async deleteRule(confirmDeletion) {
      if (confirmDeletion) {
        try {
          await EventRuleService.delete(this.itemToDelete.id);
          this.$notifier.info(`Rule '` + this.itemToDelete.name + `' deleted!`);
        } catch (error) {
          this.$notifier.error(
              `Could not delete the '` + this.itemToDelete.name + `' rule!`, {error: error}
          );
        }

        if (this.eventRules.length === 1) {
          let pageToFetch = this.page - 1
          if (this.page > 1) {
            this.page--
            pageToFetch--
          }
          this.getEventRulesFromServer({page: pageToFetch});
        } else
          this.getEventRulesFromServer();
      }
      this.confirmDialog = !this.confirmDialog;
    },
    async updateEditRule(id, params) {
      params.expression = JSON.stringify(this.query);
      delete params.index
      delete params.id
      try {
        await EventRuleService.put(id, params);

        this.getEventRulesFromServer();
        this.$notifier.info(`Rule '` + params.name + `' edited successfully!`);
      } catch (error) {
        this.getEventRulesFromServer();
        this.$notifier.error(`Could not edit the '` + params.name + `' rule!`, {error: error});
        console.error(error);
      }
    },
    async updateRuleSwitch(params) {
      let id = params.id
      delete params.id
      delete params.index
      try {
        await EventRuleService.put(id, params);
        if (params.enabled) this.$notifier.info(`Rule '` + params.name + `' enabled!`);
        else this.$notifier.info(`Rule '` + params.name + `' disabled!`);
      } catch (error) {
        console.error(error);
        if (params.enabled) {
          setTimeout(() => {
            this.eventRules.find((el) => el.id === id).enabled = false;
          }, 80);

          this.$notifier.error('Could not enable the rule', {error: error});
        } else {
          setTimeout(() => {
            this.eventRules.find((el) => el.id === id).enabled = true;
          }, 80);
          this.$notifier.error('Could not disable the rule', {error: error});
        }
      }
    },
    // switchRule(itemEnabled, id, name, namespace) {
    switchRule(itemEnabled, item) {
      // var paramObj = Object.assign(
      //   {},
      //   {
      //     enabled: itemEnabled,
      //   }
      // );
      var params = JSON.parse(JSON.stringify(item))
      this.updateRuleSwitch(params);
    },
    editRule(item) {
      this.newEventRuleObject = Object.assign({}, item);
      this.query = Object.assign({}, JSON.parse(item.expression));
      if (Object.keys(this.query).length === 0) {
        this.query.logicalOperator = "all";
      }
      this.edit = true;
      this.add = false;
    },
    async postNewRule() {
      if (!this.newEventRuleObjectForDialog.namespace)
        this.newEventRuleObjectForDialog.namespace = "";
      if (!this.newEventRuleObjectForDialog.description)
        this.newEventRuleObjectForDialog.description = "";

      this.newEventRuleObjectForDialog.application = "PG";
      this.newEventRuleObjectForDialog.expression = JSON.stringify({
        children: [],
        logicalOperator: "all",
      });
      await EventRuleService.post(this.newEventRuleObjectForDialog)
          .then((response) => {
            this.$notifier.info('New rule saved!');
            this.getEventRulesFromServer();
          })
          .catch((error) => {
            console.error(error);
            this.$notifier.error('Could not save new rule', {error: error});
          });

      this.dialog = !this.dialog;
      this.newEventRuleObjectForDialog = Object.assign(
          {},
          defaultEventRule.eventRule
      );
      // this.query = {};
    },
    saveHandler() {
      this.add
          ? this.postNewRule()
          : this.edit
              ? this.updateEditRule(
                  this.newEventRuleObject.id,
                  JSON.parse(JSON.stringify(this.newEventRuleObject))
              )
              : 0;
    },
    getEventRulesFromServer(extraParams = null) {
      this.error = false;
      let params = this.getDefinitionsQueryParams();
      if (extraParams != null)
        params = Object.assign(params, extraParams);

      EventRuleService.query({params: params})
          .then((response) => {
            this.loading = false;
            if (response.data.content) {
              this.eventRules = response.data.content.map((el, index) => {
                el.index = index;
                return el;
              });
              this.totalPages = response.data.totalPages;
            }
          })
          .catch((error) => {
            this.errorMessage = error;
            this.error = true;
            this.loading = false;
            this.$notifier.warn('Could not refresh the data');
          });
    },
    addEventRule() {
      this.expanded = []
      this.newEventRuleObjectForDialog = Object.assign(
          {},
          defaultEventRule.eventRule
      );
      this.getApplications();
      this.add = true;
      this.edit = false;
      this.dialog = !this.dialog;
    },
    getApplications() {
      ApplicationService.get()
          .then((response) => (this.applications = response.data))
          .catch(() =>
              this.$notifier.warn(
                  'There was a problem receiving info about the applications from the server'
              )
          );
    },
  },
  watch: {
    dialog(value) {
      this.$nextTick(() => {
        this.$refs.confRulesForm.reset();
      });
    },
  },
};
</script>
<style lang="scss">
@import "../css/bootstrap/css/bootstrap.min.css";

.queryBuilder--dark {
  @import "../assets/query-builder-styles/override-Style-Dark";
}

.queryBuilder--light {
  @import "../assets/query-builder-styles/override-Style-Light";
}

.subscription-groups-label {
  font-size: 0.7em;
}
</style>
<style src="../css/utilities/eventRules.css"></style>
<style scoped src="../css/utilities/scoped/eventRules.css"></style>
